import { useMemo } from 'react'

import {
  IConditionalField,
  IPermitTypeField,
  PermitFieldType,
} from '~/client/graph/types.generated'
import { nonConditionalPermitFieldTypes } from '~/client/src/shared/constants/PermitFieldTypeConstants'
import { MAX_CONDITIONAL_DEPTH_LEVEL } from '~/client/src/shared/constants/permitTypeFieldsConstants'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { IResourceRecord } from '~/client/src/shared/resources/definitions/types'

import {
  flattenRuleKeys,
  getAvailableSelectOptions,
  getSelectOptions,
} from '../utils/ruleHelpers'

export function useFieldOptions(
  field: IPermitTypeField,
  depthLevel: number,
  allConditionalFields: IConditionalField[],
  allowedLocationIds: string[],
  materialResourceRecords?: IResourceRecord[],
) {
  const existingRuleKeys = useMemo(() => {
    const keys =
      allConditionalFields
        ?.filter(cf => cf.fieldId === field?.id)
        .map(rule => rule.key) || []
    return flattenRuleKeys(keys)
  }, [allConditionalFields, allConditionalFields.length, field?.id])

  const selectOptions = useMemo(() => {
    return getSelectOptions(field, allowedLocationIds, materialResourceRecords)
  }, [
    field,
    allowedLocationIds,
    materialResourceRecords,
    Localization.state.currentLanguage,
  ])

  const availableSelectOptions = useMemo(() => {
    return getAvailableSelectOptions(selectOptions, existingRuleKeys)
  }, [selectOptions, existingRuleKeys])

  const restrictedFieldTypes = useMemo(() => {
    return depthLevel === MAX_CONDITIONAL_DEPTH_LEVEL
      ? nonConditionalPermitFieldTypes.concat(PermitFieldType.Table)
      : nonConditionalPermitFieldTypes
  }, [depthLevel])

  return {
    selectOptions,
    availableSelectOptions,
    restrictedFieldTypes,
  }
}
